import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { TID } from "@/constants/testIds";

const reviews = [
  {
    q: "Un libro davvero illuminante che va dritto al punto, perfetto per chi vuole fare il salto di qualità nel digitale. Leggendolo ti sembra di avere accanto un mentore che ti spiega come muoverti con disinvoltura e professionalità nel lavoro di oggi.",
    a: "Marianna Bracco",
    role: "★★★★★ · Acquisto verificato · 25 mag 2026",
    stars: 5,
  },
  {
    q: "Questo libro unisce esperienza personale, disciplina militare e visione imprenditoriale moderna. Il mare diventa una metafora della gestione dell'incertezza, della capacità di mantenere lucidità sotto pressione e dell'importanza del lavoro di squadra.",
    a: "Vervy",
    role: "★★★★★ · Acquisto verificato · 20 mag 2026",
    stars: 5,
  },
  {
    q: "Mi sono innamorato del personaggio: giovane ma pieno di talento. Sapendo che ha fatto 9 anni sulla Vespucci per me è stato sufficiente — non c'è scuola di vita migliore per diventare la migliore versione di sé stessi.",
    a: "Massimo",
    role: "★★★★★ · Acquisto verificato · 4 giu 2026",
    stars: 5,
  },
  {
    q: "Ottimo libro molto curato e dettagliato in ogni sua pagina, scritto da esperienze vere. Ho trovato tantissimi consigli validi per imparare a delegare e rendere responsabili le altre persone. Scorrevole, pratico e di grande aiuto.",
    a: "Maurizio Montemezzi",
    role: "★★★★★ · Acquisto verificato · 19 mag 2026",
    stars: 5,
  },
  {
    q: "Un vero percorso di crescita personale e professionale. Il mare diventa metafora della vita: per arrivare lontano servono visione, equilibrio, sacrificio e fiducia nelle persone che navigano con noi. Una lettura che ispira e lascia il segno.",
    a: "Giuliana",
    role: "★★★★★ · 16 mag 2026 · Paperback",
    stars: 5,
  },
  {
    q: "La guida è chiara e approfondita: un metodo di leadership per eccellere nel mondo digitale. Con questo libro non improvviserete più ma avrete risultati concreti applicando questo metodo testato!",
    a: "Alessandra Sergi",
    role: "★★★★★ · Acquisto verificato · 21 mag 2026",
    stars: 5,
  },
];

export default function Testimonials() {
  return (
    <section
      id="reviews"
      data-testid={TID.testimonialsSection}
      className="py-24 md:py-32 bg-gradient-to-br from-[#D6E5EC] via-[#E8F1F4] to-[#F4E8D6] border-t border-[#E5E1DA]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10 mb-16 items-end">
          <div className="md:col-span-6">
            <p className="overline">Recensioni Amazon verificate</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.05]">
              4,9 su 5.
              <br />
              <em className="text-[#E89B6C]">33 voci reali.</em>
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8">
            <div className="flex items-center gap-2 mb-4">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  size={20}
                  fill="#D4B895"
                  strokeWidth={0}
                  className="text-[#D4B895]"
                />
              ))}
              <span className="ml-2 font-serif-display text-2xl text-[#0B192C]">
                4,9/5
              </span>
            </div>
            <p className="text-lg font-light text-[#3A4F6B]">
              Recensioni reali con acquisto verificato pubblicate su Amazon
              Italia. Clicca qui sotto per leggerle tutte direttamente sulla pagina prodotto.
            </p>
            <a
              href="https://amzn.eu/d/0iLs59IO"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="testimonials-amazon-link"
              className="inline-block mt-4 text-sm uppercase tracking-[0.2em] link-underline text-[#0B192C]"
            >
              Leggi tutte su Amazon →
            </a>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E5E1DA] border border-[#E5E1DA]">
          {reviews.map((r, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              className="bg-[#FFFFFF] p-8 md:p-10"
              data-testid={`testimonial-${i}`}
            >
              <div className="flex gap-1 mb-4">
                {[...Array(r.stars)].map((_, j) => (
                  <Star
                    key={j}
                    size={14}
                    fill="#D4B895"
                    strokeWidth={0}
                    className="text-[#D4B895]"
                  />
                ))}
              </div>
              <p className="font-serif-display italic text-xl md:text-2xl leading-snug text-[#0B192C]">
                "{r.q}"
              </p>
              <div className="mt-6 flex items-baseline gap-3">
                <span className="h-px w-6 bg-[#0B192C]" />
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-[#0B192C]">
                    {r.a}
                  </p>
                  <p className="text-xs text-[#3A4F6B] mt-1">{r.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
